import React from 'react';
import { Dumbbell, Lock } from 'lucide-react';
import GoogleSignInButton from './GoogleSignInButton';

export default function PracticePaywall({ email, expired, checking, busy, error, onSignIn, onSignInError, onSignOut, onSubscribe }) {
  return (
    <div className="disease-game-paywall">
      <Dumbbell className="disease-game-icon disease-game-paywall-icon" />
      <h2 className="disease-game-win-title">Practice Mode</h2>
      <p className="disease-game-win-text">
        {expired
          ? 'Your subscription has ended. Subscribe again to keep practising.'
          : 'Play as many random diseases as you like. Practice games don\'t affect your daily streak.'}
      </p>

      {!email ? (
        <>
          <p className="disease-game-win-subtext">Sign in with Google to subscribe or to restore your subscription on this device.</p>
          <GoogleSignInButton onCredential={onSignIn} onError={onSignInError} />
        </>
      ) : checking ? (
        <p className="disease-game-win-subtext">Checking your subscription...</p>
      ) : (
        <button onClick={onSubscribe} disabled={busy} className="disease-game-share-button">
          <Lock className="disease-game-share-icon" />
          {busy ? 'Opening checkout...' : 'Unlock for $1/month'}
        </button>
      )}

      {email && (
        <p className="disease-game-win-subtext">
          Signed in as {email} ·{' '}
          <button onClick={onSignOut} className="disease-game-link-button">Sign out</button>
        </p>
      )}

      <p className="disease-game-win-subtext">
        Secure payment by Stripe. Cancel anytime.{' '}
        <a href="/terms.html" className="disease-game-footer-link">Terms</a>
        {' · '}
        <a href="/privacy.html" className="disease-game-footer-link">Privacy</a>
      </p>

      {error && <p className="disease-game-paywall-error">{error}</p>}
    </div>
  );
}
